angular.module 'app'
.factory 'Storage',  ->
  set: (key, data) ->
      return window.sessionStorage.setItem(key, window.JSON.stringify(data))
  get: (key) ->
      if window.sessionStorage.getItem(key) == null || window.sessionStorage.getItem(key) == 'undefined'
        return null
      else
        return window.JSON.parse(window.sessionStorage.getItem(key))

  remove: (key) ->
      return window.sessionStorage.removeItem(key)

.factory 'CreateDateText', ->
  format: (date) ->
    dateText = moment(date).format('YYYY/MM/DD ahh:mm')
    dateText = dateText.replace('am', '上午')
    dateText = dateText.replace('pm', '下午')
    return dateText

.factory 'CreateHtml', ($sce) ->
  toHtml: (text) ->
    return $sce.trustAsHtml(text)

.factory 'SocketIO', (socketFactory, config) ->
  return socketFactory(
    ioSocket: io.connect(config.esocket.baseUrl)
  )
